var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.indexStyle == 1 ? _c("index-chart") : _vm._e(),
      _vm.indexStyle == 2 ? _c("index-bdc") : _vm._e(),
      _vm.indexStyle == 3 ? _c("index-task") : _vm._e(),
      _c(
        "div",
        {
          staticStyle: {
            width: "100%",
            "text-align": "right",
            "margin-top": "20px"
          }
        },
        [
          _vm._v("\n    请选择首页样式：\n    "),
          _c(
            "a-radio-group",
            {
              model: {
                value: _vm.indexStyle,
                callback: function($$v) {
                  _vm.indexStyle = $$v
                },
                expression: "indexStyle"
              }
            },
            [
              _c("a-radio", { attrs: { value: 1 } }, [_vm._v("统计图表")]),
              _c("a-radio", { attrs: { value: 2 } }, [_vm._v("统计图表2")]),
              _c("a-radio", { attrs: { value: 3 } }, [_vm._v("任务表格")])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }